'use client';

import { useServiceWorkerNavigation } from '@/hooks/use-service-worker-navigation';

export function ServiceWorkerNavigationHandler() {
  useServiceWorkerNavigation();
  return null;
}
